<template>
    <div class="relativ">
        <div class=" bg-clay-100">
        <div class="">
                <nav aria-label="Breadcrumb" class="hidden bg-opacity-50 border-b border-gray-200 bg-clay-900 lg:flex">
                    <ol class="flex w-full max-w-screen-xl px-4 mx-auto space-x-4 sm:px-6 lg:px-8" role="list">
                        <li class="flex">
                            <div class="flex items-center">
                                <a class="ml-4 text-sm font-medium text-zinc-200 hover:text-zinc-100"
                                    href="/quizzes">All Quizzes</a>
                            </div>
                        </li>

                        <li class="flex">
                            <div class="flex items-center">
                                <svg aria-hidden="true" class="w-6 h-full shrink-0 text-clay-700"
                                    fill="currentColor" preserveAspectRatio="none" viewBox="0 0 24 44"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                                </svg>
                                <span aria-current="page" class="ml-4 text-sm font-semibold text-clay-50">{{ quiz.title
                                    }}</span>
                            </div>
                        </li>
                    </ol>
                </nav>

            </div>
            <header class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div class="py-8 mx-auto max-w-7xl">
                    <div class="">
                        <div class="py-6 overflow-hidden text-center rounded-2xl">
                            <div class="md:flex md:space-x-12">

                                <div class="relative min-w-full mt-0 md:text-center md:-mt-5 md:pt-1">
                                    <p class="block sm:hidden "><a href="/quizzes"
                                            class="px-2 py-1 mb-4 text-xs border rounded-lg text-clay-600 hover:shadow">Back
                                            to Quiz Search</a></p>

                                    <h1
                                        class="pt-0 mt-4 mb-2 text-2xl font-bold text-clay-950 mb:mt-8 md:text-4xl md:mt-0 mb:pt-4">
                                        {{ quiz.title }}</h1>

                                    <p class="text-lg font-medium md:mb-3 text-clay-900"> {{ quiz.description }}</p>

                                    <div class="items-center text-center">

                                    </div>
                                    
                                    <div v-if="quiz.guides?.length > 0" class="mt-4 space-y-3">
                                        <p class="mb-2 space-x-2 text-sm text-clay-800">Guides associated with this
                                            quiz:</p>
                                        <p class="mb-3 space-x-2">
                                            <a v-for="guide in quiz.guides" :key="guide.id" :href="`/${guide.id}`"
                                                class="inline-flex items-center rounded-full bg-clay-200 hover:border px-3 py-0.5 text-sm text-clay-950">
                                                {{ guide.title }}</a>
                                        </p>
                                    </div>
                                    <div class="items-center hidden text-center md:block">
                                        <span class="text-xs">keywords: </span>
                                        <a v-for="tag in quiz.tags" :key="tag"
                                            :href="`/search?term=${encodeURIComponent(tag)}&category=quizzes`"
                                            class="inline-flex px-2 py-1 m-1 mb-2 text-xs font-medium border rounded-full text-clay-800 bg-clay-50 hover:border-clay-900 hover:border hover:text-clay-700 hover:bg-clay-100">
                                            {{ tag }}
                                        </a>
                                    </div>
                                    <div class="flex justify-center mt-0 space-x-3">
                                        <span
                                            class="inline-flex text-white rounded-md shadow-sm bg-opacity-40 isolate action-bar share-solo bg-clay-800">
                                            <SaSocialShare :title="quiz.title" />
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </header>
            
        </div>
    </div>
    <div class="mx-auto max-w-7xl">

        <main  role="main">

            <div class="mx-auto max-w-7xl">

                <div class="">
                    <div class="flex h-full min-h-screen">

                        <div class="flex-1 min-w-0 overflow-visible md:flex sm:px-6 lg:px-8">
                            <div class="z-0 flex flex-1 mb-12 overflow-visible sm:bg-white">
                                <div class="relative z-0 flex-1 pt-6 overflow-y-auto focus:outline-hidden xl:order-last">

                                    <div class="relative inset-0 px-4 pb-6 sm:px-6 lg:px-8">
                                        <div class="h-full rounded-lg">
                                            <div class="pt-5 pl-4 pr-4 contentful-tab">
                                                <div class="guidesTab md:h-full">
                                                    <section>
                                                        <form v-if="!isAuthenticated"
                                                            class="justify-center min-w-full space-y-5 prose prose-lg prose-slate ">

                                                            <sa-walled content-for="AtLeastBasic" class="max-w-3xl mx-auto">

                                                                <template v-slot:teaser>
                                                                    <section
                                                                        class="p-8 bg-gradient-to-b from-white via-white to-clay-500 rounded-xl">
                                                                        <div
                                                                            class="min-w-full text-lg text-transparent walled-teaser bg-clip-text bg-gradient-to-b from-clay-500 to-white">
                                                                            <div v-for="(question, questionIndex) in quiz.questions.slice(0, 3)"
                                                                                :key="question.id" class=" question text-clay-950/50">
                                                                                <div
                                                                                    class="col-sm-12 ">
                                                                                    <p class="p-2 m-0 font-semibold">{{
                                                                                        question.title }}
                                                                                    </p>
                                                                                    <div v-if="question.hasImageUrl"
                                                                                        class="text-center row">
                                                                                        <div class="mb-3 col-md-12">
                                                                                            <figure
                                                                                                class="p-0 m-0 text-center figure">
                                                                                                <img :alt="question.title"
                                                                                                    :src="question.imageUrl"
                                                                                                    class="m-0 rounded figure-img img-fluid">
                                                                                            </figure>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div class=" text-clay-950/50">
                                                                                    <div
                                                                                        v-if="question.type === 'multiselect'">
                                                                                        <em>Check all that apply.</em>
                                                                                        <fieldset
                                                                                            v-for="(answer, answerIndex) in question.answers"
                                                                                            :key="answer.id"
                                                                                            class="space-x-3">
                                                                                            <input :id="answer.id"
                                                                                                v-model="quizToGrade.questions[questionIndex].selectedAnswers"
                                                                                                :value="answer.id"
                                                                                                type="checkbox">
                                                                                            <label :for="answer.id">{{
                                                                                                answer.text
                                                                                                }}</label>
                                                                                        </fieldset>
                                                                                    </div>
                                                                                    <div v-else>
                                                                                        <fieldset
                                                                                            v-for="(answer,answerIndex) in question.answers"
                                                                                            :key="answer.id"
                                                                                            class="space-x-3">
                                                                                            <input :id="answer.id"
                                                                                                v-model="quizToGrade.questions[questionIndex].selectedAnswers"
                                                                                                :value="answer.id"
                                                                                                type="radio">
                                                                                            <label :for="answer.id">{{
                                                                                                answer.text
                                                                                                }}</label>
                                                                                        </fieldset>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </section>
                                                                </template>
                                                                
                                                                <template v-slot:content-title>
                                                                    to take the quiz <span
                                                                        class="italic font-semibold">{{quiz.title}}</span>
                                                                    and to unlock other amazing theatre resources!
                                                                </template>



                                                            </sa-walled>

                                                        </form>
                                                        <form v-else
                                                            class="justify-center min-w-full space-y-5">

                                                            <ErrorSummary :response-status="responseStatus" />

                                                            <div v-for="(question, questionIndex) in quiz.questions"
                                                                :key="question.id"
                                                                class="px-5 py-3 mb-2 bg-white sm:px-0 sm:py-0 question sm:rounded-none rounded-2xl prose prose-lg prose-slate">
                                                                <div class="col-sm-12 ">
                                                                    <h4 class="py-2 m-0">{{ question.title }}</h4>
                                                                    <div v-if="question.hasImageUrl"
                                                                        class="text-center row">
                                                                        <div class="mb-3 col-md-12">
                                                                            <figure class="p-0 m-0 text-center figure">
                                                                                <img :alt="question.title"
                                                                                    :src="question.imageUrl"
                                                                                    class="m-0 rounded figure-img img-fluid">
                                                                            </figure>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="px-5 py-3 pl-4 mb-2 bg-white col-sm-12 sm:px-0 sm:py-0 question blue lighten-5 sm:rounded-none rounded-2xl">
                                                                    <div v-if="question.type === 'multiselect'">
                                                                        <em>Check all that apply.</em>
                                                                        <fieldset
                                                                            v-for="(answer, answerIndex) in question.answers"
                                                                            :key="answer.id" class="space-x-3">
                                                                            <input :id="answer.id"
                                                                                v-model="quizToGrade.questions[questionIndex].selectedAnswers"
                                                                                :value="answer.id" type="checkbox">
                                                                            <label :for="answer.id">{{ answer.text
                                                                                }}</label>
                                                                        </fieldset>
                                                                    </div>
                                                                    <div v-else>
                                                                        <fieldset
                                                                            v-for="(answer,answerIndex) in question.answers"
                                                                            :key="answer.id" class="space-x-3">
                                                                            <input :id="answer.id"
                                                                                v-model="quizToGrade.questions[questionIndex].selectedAnswers"
                                                                                :value="answer.id" type="radio">
                                                                            <label :for="answer.id">{{
                                                                                answer.text
                                                                                }}</label>
                                                                        </fieldset>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <SaButton id="btnGradeQuiz" @click.prevent="submit" :loading="isSubmitting" variant="primary">
                                                                <template #loading>
                                                                    <span class="font-semibold">Grading...</span>
                                                                </template>
                                                                <span class="font-semibold">Grade Quiz</span>
                                                            </SaButton>
                                                        </form>
                                                    </section>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex hidden mb-12 overflow-visible w-80">
                                <div class="">
                                    <div class="relative inset-0 px-4 pb-6 sm:px-6 lg:px-8"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </main>
    </div>


</template>

<script lang="ts" setup>
import {defineProps, ref} from "vue";
import {client} from '@/shared';
import {GradeQuiz, GradeQuizResponse, QuestionToGrade} from "@/dtos";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import {store} from "@/store";
import SaSocialShare from "@/main/components/SaSocialShare.vue";
import SaButton from "@/main/components/SaButton.vue";

const props = defineProps<{
    quiz: any
}>();
const quiz = ref(props.quiz);

const quizToGrade = ref(new GradeQuiz({
    quizId: quiz.value.id,
    questions: quiz.value.questions.map( (q:any) => new QuestionToGrade({
        id: q.id,
        selectedAnswers: []
    }))
}));

const isAuthenticated = ref(store.saUserSession.isAuthenticated);

const responseStatus = ref(null);
const takeQuizSuccessful = ref(false);
const isSubmitting = ref(false);
const submit = async () => {
    if (!isAuthenticated.value) {
        store.showLoginDialog = true;
        return;
    }
    isSubmitting.value = true;
    takeQuizSuccessful.value = false;
    await client.post<GradeQuizResponse>(quizToGrade.value)
        .then(response => {
            takeQuizSuccessful.value = true;
            window.location.href = `/${response.quizId}/grade`;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    isSubmitting.value = false;
};
</script>
<style>

</style>